export const sampleColors = [
  '#11A579',
  '#E83f74',
  '#9F5DC8',
  '#EF8205',
  '#29B3B2',
  '#E54F3B',
  '#59BB12',
  '#EF57BA',
  '#E2AF00',
  '#12AADE',
]
